/**
 * @generated SignedSource<<6c58c19887db56e2857170d1242e5884>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SpecializationsFields_User$data = {
  readonly profile: {
    readonly industry: {
      readonly id: string;
    } | null | undefined;
    readonly specializations: ReadonlyArray<{
      readonly id: string;
      readonly name: string;
      readonly " $fragmentSpreads": FragmentRefs<"Specialization_Specialization">;
    }> | null | undefined;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"SpecializationFieldsDialog_User">;
  readonly " $fragmentType": "SpecializationsFields_User";
};
export type SpecializationsFields_User$key = {
  readonly " $data"?: SpecializationsFields_User$data;
  readonly " $fragmentSpreads": FragmentRefs<"SpecializationsFields_User">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SpecializationsFields_User",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Profile",
      "kind": "LinkedField",
      "name": "profile",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Industry",
          "kind": "LinkedField",
          "name": "industry",
          "plural": false,
          "selections": [
            (v0/*: any*/)
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Specialization",
          "kind": "LinkedField",
          "name": "specializations",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "Specialization_Specialization"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SpecializationFieldsDialog_User"
    }
  ],
  "type": "User",
  "abstractKey": null
};
})();

(node as any).hash = "722d9e622a147cbaf9618644a46def29";

export default node;
